import createAction from 'redux-actions/lib/createAction';

export const ROOT_MODAL_CLOSED = 'modal/ROOT_MODAL_CLOSED';
export const rootModalClosed = createAction(ROOT_MODAL_CLOSED);
